import {
    $, addAction, INIT, LAYOUT,
} from '@situation/setdesign.util';

// Must match $bg-textured-travel in styles/utilities/_background.scss
const TRAVEL_FACTOR = 0.15;

// Fallback for browsers without CSS scroll-driven animations; everywhere else the
// parallax runs entirely in CSS (see bg-textured-parallax in _background.scss)
function initParallax() {
    const $elements = $(
        '.content-section--bg-secondary-textured, .content-row--bg-secondary-textured, .content-column--bg-secondary-textured',
    );
    let viewportHeight;
    let ticking = false;
    if (
        !$elements.length
        || CSS.supports('animation-timeline: view()')
        || window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
        return;
    }

    const updateParallax = () => {
        // Read all positions before writing to avoid layout thrashing
        const rects = $elements.toArray().map((el) => el.getBoundingClientRect());
        $elements.each((i, el) => {
            const rect = rects[i];
            if (rect.bottom < 0 || rect.top > viewportHeight) {
                return;
            }

            // 0 when the element enters at the bottom of the viewport, 1 when it leaves at the top
            const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height);
            const offset = (progress * 2 - 1) * rect.height * TRAVEL_FACTOR;
            el.style.setProperty('--parallax-offset', `${offset.toFixed(2)}px`);
        });

        ticking = false;
    };

    const requestTick = () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(updateParallax);
        }
    };

    const measure = () => {
        viewportHeight = SetDesign.viewport.height();
        requestTick();
    };

    measure();
    addAction(LAYOUT, measure);
    $(window).on('scroll', requestTick);
}

addAction(INIT, initParallax, 20);
